export const berthKeys = {
  all: ['berth'] as const,
  managements: () => [...berthKeys.all, 'managements'] as const,
  management: (tenantId: string, warehouseId: string, bookingDate: string, berthId: string) =>
    [...berthKeys.managements(), { tenantId, warehouseId, bookingDate, berthId }] as const,
  lists: () => [...berthKeys.all, 'list'] as const,
  list: (tenantId: string, warehouseId: string) =>
    [...berthKeys.lists(), { tenantId, warehouseId }] as const,
  groups: () => [...berthKeys.all, 'group'] as const,
  group: (tenantId: string) => [...berthKeys.groups(), { tenantId }] as const,
  permissions: () => [...berthKeys.all, 'permission'] as const,
  permission: (tenantId: string) => [...berthKeys.permissions(), { tenantId }] as const,
  latestInPasts: () => [...berthKeys.all, 'latestInPast'] as const,
  latestInPast: (tenantId: string, berthId: string, startDate: string, startTime: string) =>
    [...berthKeys.latestInPasts(), { tenantId, berthId, startDate, startTime }] as const,
}

export const bookingKeys = {
  all: ['booking'] as const,
  masterData: () => [...bookingKeys.all, 'masterData'] as const,
  masterDataByTenant: (tenantId: string) => [...bookingKeys.masterData(), { tenantId }] as const,
  unassigned: () => [...bookingKeys.all, 'unassigned'] as const,
  unassignedByParams: (tenantId: string, warehouseId: string, bookingDate: string) =>
    [...bookingKeys.unassigned(), { tenantId, warehouseId, bookingDate }] as const,
  details: () => [...bookingKeys.all, 'detail'] as const,
  detail: (bookingId: string) => [...bookingKeys.details(), { bookingId }] as const,
}

export const tenantKeys = {
  all: ['tenant'] as const,
  settings: () => [...tenantKeys.all, 'settings'] as const,
  settingsByTenant: (tenantId: string) => [...tenantKeys.settings(), { tenantId }] as const,
}

export const userKeys = {
  all: ['user'] as const,
  info: () => [...userKeys.all, 'info'] as const,
}

export const deliveryDestinationKeys = {
  all: ['deliveryDestination'] as const,
  lists: () => [...deliveryDestinationKeys.all, 'list'] as const,
  list: (tenantId: string, page: number, perPage: number) =>
    [...deliveryDestinationKeys.lists(), { tenantId, page, perPage }] as const,
}

export const companyKeys = {
  all: ['company'] as const,
  lists: () => [...companyKeys.all, 'list'] as const,
  list: (tenantId: string) => [...companyKeys.lists(), { tenantId }] as const,
  details: () => [...companyKeys.all, 'detail'] as const,
  detail: (tenantId: string, warehouseId: string, companyId: string, type: string) =>
    [...companyKeys.details(), { tenantId, warehouseId, companyId, type }] as const,
}
